export default {
    // title
    titleMarketUpdates: '市场动态',
    titleTrendingCompanies: '热门公司',
    titleInvite: "邀请并获得奖励",
    titleOnboarding: "入门工具",



    // trending companies

    // invite
    forReferrals: "推荐人：",
    inviteBtn: '邀请',
    copyLink: '复制链接',
    shareYourReferralLink: '分享您的推荐链接或输入电子邮件邀请他人。加入即可获得奖励！',
    forTeamInvites: "对于团队邀请（获得积分）：",
    assignTeamInvites: "指定团队邀请",
    lookingToGrowYourTeam: "想发展你的团队吗？每次有人加入时，分配邀请并开始赚取积分！",
    addMultipleAddresses: "添加多个用逗号分隔的地址并按回车",
    greatProgress: "进步很大！继续邀请解锁全部{count}积分。",
    startInviting: '开始邀请并获得高达 {count} 个积分！',
    allSet: "准备就绪！您已获得 {count} 积分，感谢您的邀请！",


    // custom insight
    addYourOwnCustomInsights: "添加您自己的自定义见解",
    companyKeyMilestones: "公司的关键里程碑",
    listMajorCompetitors: "列出同行业的主要竞争对手",
    analyzeMarketPresence: "分析公司的市场占有率",
    poweredByAi: "由 AI 提供技术支持",


    // onboarding kit
    grantedUponCompletion: '{count} 积分将在完成后获得',
    granted_complete: '已获得 {count} 信用点数奖励！',

    // ai
    meetRonnaAi: "认识RonnaAi-您的智能商务助理",
    askAnything: "问点什么...",
    askQuestionsExploreStrategies: '提出问题，探索策略，或获得为您量身定制的即时见解。',
    limitedView: "受限视图",
    viewFullCompanyDetails: "查看完整的公司详细信息",
    recentThreads: "最近搜索",
    recentlyViewed: "最近查看",
    companyAndWebsite: "公司 / 网站",
    noResultsAskAi: "没有结果？向RonnaAI询问相关信息",
    allSearchResultsFor: "{count} 的所有搜索结果",
    searchForAnything: "搜索任何东西...",
    pressEnter: "按回车键",
    askRonnaAI: "询问RonnaAI：",
    clickToChatWithRonnaAI: "点击与RonnaAI聊天，了解更多详情",
    useRonnaAIToExploreBusinessDirectories: "使用RonnaAI即时探索业务目录、见解等。",
    ronnaAI: "RonnaAI",
    findSearchHistory: "寻找搜索历史",
    Today: '今天',
    "7 Days": "7天内",
    '30 Days': "更多",
    deleteRecord: "删除记录",
    newChat: "创建新对话",
    aiTabAnswer: "回答",
    aiTabCompanies: "公司",
    aiTabSources: "资源",
    processingYourRequest: "正在处理您的请求...",
    thinkingDeeply: "深入思考中",
    generatingAPlan: "生成计划中",
    noHistoryYet: "暂无历史",

    // advertisement
    targetLocation: "目标投放区域",
    open_ad: "打开广告",
    ad_type_label: {
      text: "文字素材",
      image: "图片素材",
      video: "视频素材",
      carousel: "轮播素材",
      other: "素材",
    },
    est_impressions: "预估展示量",
    ads: "广告",

    // expansion signals (Phase 1)
    expansion: {
        companyFacts: {
          duplicateProfileNotice: "这是重复的公司档案。",
          viewCurrentProfile: "查看当前档案",
          duplicateProfileTip: "该档案为重复项，请打开当前档案",
        },
        jobsInsights: {
            heading: "招聘动态",
            windowReadout: "最近 {n} 天",
            windowHint: "统计该时间段内的在招职位",
            kpiOpen: "在招职位",
            kpiPosted: "新发布职位",
            openSub: "共 {n} 个在招",
            kpiPace: "招聘节奏",
            kpiTopFunction: "主要职能",
            kpiMarkets: "覆盖地区",
            newSub: "新增 {n}",
            trendVsPrior: "较上期",
            marketShare: "{pct}% {place}",
            nRoles: "{n} 个职位",
            momentumLabel: "招聘走势",
            velAccel: "加速中",
            velSlow: "放缓中",
            velSteady: "平稳",
            mover: "{flag} {place} — 过去一个月 {n} 个职位",
            moverSenior: "{flag} {place} — 过去一个月 {n} 个职位，多为 {tier}",
            moverNew: "· 新市场",
            exploreLabel: "探索",
            exploreHint: "点击柱状条，看职能、地区与职级如何关联",
            showingOf: "{total} 个中的 {n} 个",
            clearAll: "清除",
            listFilteredBy: "筛选条件：",
            notClassified: "{n} 个未分类",
            openListTitle: "新发布职位",
            openListNote: "发布于 · {window}",
            leadTopFunction: "{label} 居首——{count} 个职位",
            leadTopLocation: "{pct}% 在 {place}",
            tier_executive: "高管",
            tier_director: "总监",
            tier_manager: "经理",
            tier_senior: "资深",
            tier_junior: "初级",
            byFunction: "按职能",
            byLocation: "按地区",
            bySeniority: "按职级",
            thisCompany: "该公司",
            narrFast: "{company} 正在快速扩张——最近 {days} 天发布了 {n} 个职位，较上期增长 {pct}%。",
            narrUp: "{company} 正在积极招聘——最近 {days} 天新增 {n} 个职位，较上期增长 {pct}%。",
            narrSteady: "{company} 招聘保持平稳——最近 {days} 天发布 {n} 个职位，与上期持平。",
            narrDown: "{company} 招聘有所放缓——最近 {days} 天发布 {n} 个职位，较上期下降 {pct}%。",
            narrQuiet: "{company} 有 {open} 个在招职位，但近期发布活动较少。",
            narrMix: "以 {fn} 为主，集中在 {loc}。",
            narrMixSenior: "以 {fn} 为主，集中在 {loc}，其中 {pct}% 为管理层职位。",
            loadError: "无法加载招聘洞察",
            retry: "重试",
            none: "—",
        },
        adsInsights: {
            eyebrow: "广告动态",
            openListTitle: "进行中的广告",
            lead: "在 {markets} 个市场投放 {n} 个广告",
            kpiActive: "进行中广告",
            kpiMarkets: "覆盖市场",
            kpiTopChannel: "主要渠道",
            kpiTopFormat: "主要格式",
            leadReach: "触达高达 {reach}",
            kpiMomentum: "投放势头",
            windowSub: "近 {n} 天",
            trendVsPrior: "较上期",
            sparkLabel: "广告投放",
            moreInsights: "更多洞察",
            lessInsights: "收起洞察",
            byReach: "按触达量（展示）",
            reach_lt_1k: "<1千",
            reach_1k_10k: "1千–1万",
            reach_10k_50k: "1万–5万",
            reach_50k_100k: "5万–10万",
            reach_100k_500k: "10万–50万",
            reach_500k_1m: "50万–100万",
            reach_1m_plus: "100万+",
            reachPeak: "峰值 {peak}",
            byMarket: "按目标市场",
            byChannel: "按渠道",
            byFormat: "按格式",
            byPlacement: "按版位",
            exploreLabel: "探索",
            exploreHint: "点击条形 — 查看触达、市场与渠道的关联",
            exploringOf: "正在探索最近 {total} 条中的 {n} 条",
            showingOf: "{total} 条广告中的 {n} 条",
            clearAll: "清除",
            leadTopMarket: "{pct}% 投放 {place}",
            leadTopChannel: "{pct}% 通过 {channel}",
            noImpression: "这些广告暂无展示量数据",
            noImpressionN: "{n} 条无展示量数据",
            noMarket: "暂无目标市场数据",
            noMarketN: "{n} 条无目标市场",
            marketLed: "主要为 {place}",
            creatives: "近期素材",
            nCampaigns: "{n} 个广告",
            loadError: "无法加载广告洞察",
            retry: "重试",
            none: "—",
        },
        newsInsights: {
            eyebrow: "媒体报道",
            lead: "过去 {days} 天 {n} 次提及",
            kpiMentions: "报道数",
            kpiMomentum: "报道势头",
            kpiPositive: "扩张信号",
            kpiRisk: "风险信号",
            kpiTopics: "主题",
            kpiSources: "来源",
            ledBy: "以 {x} 为主",
            windowSub: "近 {n} 天",
            trendVsPrior: "较上期",
            sparkLabel: "报道量",
            fundingLatest: "最新融资",
            moreInsights: "更多洞察",
            lessInsights: "收起洞察",
            byTopic: "按主题",
            byMarket: "按市场",
            openListTitle: "近期新闻",
            exploreHint: "点击主题筛选列表",
            loadError: "无法加载媒体洞察",
            retry: "重试",
            none: "—",
        },
        pitch: {
            headline: "Pubrio · 发现正在拓展新国家市场的公司。",
            body: "每天都有数千家公司进入新市场。成为第一个联系他们的人，而不是最后一个。",
            dismiss: "忽略",
        },
        kpi: {
            title: "关键扩张指标",
            mostActiveMarket: "最活跃市场",
            yourFocus: "您的关注重点",
            companiesInWindow: "{n} 家有新信号 · {window}",
            bestToContact: "最佳联系时机",
            inExpandingStage: "处于拓展阶段",
            movingUnusuallyFast: "异常快速发展中",
            aheadOfPace: "领先于常规节奏",
            hot: "热门",
            newActivity: "新动态信号",
            activeMarkets: "活跃市场",
            thisWeek: "本周",
            last30Days: "近 30 天",
            movementHeadline: "本期新动态",
            movementHint: "覆盖 {total} 个市场中的 {active} 个",
            // Tile 2-4 hint suffixes — GLOBAL mode appends a country chip,
            // SELECTED mode reuses tile 1's focus country and drops the chip.
            hintOfMarket: "占市场 {rate}",
            hintOfFocus: "占 {country} 公司 {rate}",
            hintAheadOfPaceGlobal: "{rate} 领先于节奏",
            hintAheadOfPaceFocus: "{country} 中 {rate} 领先于节奏",
            hintNewThisWeekGlobal: "{rate} 本周新增",
            hintNewThisWeekFocus: "{country} 中 {rate} 本周新增",
            // Empty state for SELECTED mode when the picked country has no data
            // in the active date window.
            noDataInWindow: "此时间范围内暂无信号",
        },
        competitive: {
            heading: "竞争扩张对比",
            subCurated: "{name} 的海外扩张与其竞争对手的对比",
            comparingAgainst: "对比对象",
            addCompetitor: "添加竞争对手",
            addSearching: "搜索中…",
            addEmpty: "未找到公司",
            removeCompetitor: "移除",
            takeawayLead: "在{metric}方面，{name} 领先于 {n} 家竞争对手。",
            takeawayRank: "在{metric}方面，{name} 在 {total} 家竞争对手中排名第 {rank}。",
            colCompany: "公司",
            colMarket: "市场",
            colActiveMarkets: "市场",
            colNewMarkets: "新市场",
            colMomentumPct: "势头",
            colSignalCount: "活跃度",
            colExpansionScore: "扩张评分",
            colWindowExpansionScore: "近期评分",
            colIndustry: "行业",
            colCountry: "总部",
            colEmployees: "员工数",
            colFounded: "成立年份",
            colWebsite: "网站",
            colTopMarket: "首要扩张市场",
            colNewestMarket: "最新进入",
            colScaling: "规模化",
            colPipeline: "储备市场",
            colMatch: "匹配度",
            columns: "列",
            columnsHint: "添加对比字段",
            fieldsGroupExpansion: "扩张指标",
            fieldsGroupCompany: "公司信息",
            you: "本公司",
            openCompany: "打开公司",
            pendingHint: "扩张数据加载中",
            empty: "暂无具备扩张数据的竞争对手。",
            cellSignals: "{n} 个信号",
            hoverHint: "将鼠标悬停在市场指标上即可查看背后的实际国家/地区。",
            coverageTitle: "市场覆盖",
            coverageSub: "各竞争对手在哪些市场、深入到何种阶段 — {total} 个市场中有 {gaps} 个是他们已进入而你尚未进入的。",
            covAll: "全部",
            covGaps: "空白",
            covYours: "本公司",
            watch: "关注市场",
            fieldCaption: "条形显示相对规模；迷你图为各竞争对手的每周活跃度走势。",
            legendStage: "颜色 = 阶段",
            legendRecent: "近期活跃",
            covYouHint: "底色 = 本公司",
            coverageCount: "{total} 家中有 {n} 家在场",
            cellTypes: "信号类型",
            cellSince: "首次发现",
            cellActive: "{t}活跃",
            sortLabel: "市场排序",
            covSortCoverage: "覆盖",
            covSortRecent: "最近",
            searchMarket: "查找市场…",
            noMarkets: "没有符合筛选的市场。",
        },
        verdict: {
            newMarkets: "新市场",
            momentum: "势头",
            expansionScore: "扩张评分",
            vsPrior: "对比上一期",
            noneThisPeriod: "本期无",
            signalsLabel: "信号",
            scoreVeryStrong: "非常强劲",
            scoreStrong: "强劲",
            scoreDeveloping: "发展中",
            scoreEarly: "早期阶段",
        },
        summary: {
            heading: "全球扩张",
            subheading: "该公司的业务覆盖地区，以及正在进入的市场。",
            subheadingCount: "覆盖全球 {n} 个市场 — 从起点到当前的增长之地。",
            founded: "成立",
            employees: "员工",
            markets: "市场",
            marketsHintFrom: "从 {hq} 向外扩张",
            marketsHintWorldwide: "全球布局",
            furthestStage: "最远阶段",
            movingNow: "当前进展",
            movingNowHint: "近 90 天内有所推进",
            upToMarkets: "最多 {n} 个市场",
            stages: "阶段",
            loading: "正在加载扩张数据…",
            empty: "尚未追踪到该公司的扩张信号。",
            emptyTitle: "正在监听扩张信号",
            emptyDetail: "暂无可显示内容。当 {company} 在新市场招聘、发布新闻或投放广告时，相关信号将在此处显示。",
            thisCompany: "该公司",
            established: "已建立",
            establishedTip: "已在这些市场运营 — 无新的扩张活动",
            establishedNote: "{company} 已在 {n} 个市场建立业务 — 此时间范围内无新的扩张活动。",
            errorTitle: "无法连接信号服务",
            errorDetail: "我们暂时无法加载扩张数据。这通常是暂时性问题 — 请稍后重试。",
            retry: "重试",
            tipMarket: "按市场筛选",
            tipDate: "更改时间范围",
            tipStage: "按生命周期阶段筛选",
            tipExport: "导出该公司",
            tipClear: "清除所有筛选",
            insight: "覆盖 {total} 个市场 · 于 {year} 年首次进入 {market} · 近 90 天内 {moving} 个有所推进",
            insightNoFirst: "覆盖 {total} 个市场 · 近 90 天内 {moving} 个有所推进",
            timeAll: "全部时间",
            time12m: "12个月",
            time6m: "6个月",
            time3m: "3个月",
            filterFocus: "关注市场",
            filterAll: "所有市场",
            filterMore: "+{n} 个更多",
            filterClear: "清除",
            filterShowing: "{total} 个市场中的 {n} 个",
        },
        pulse: {
            heading: "动态脉搏",
            windowHint: "时间窗口跟随上方的日期筛选",
            catHiring: "招聘",
            catMarketing: "营销与公关",
            catProduct: "产品与技术",
            catFootprint: "布局足迹",
            catPartners: "合作伙伴",
            leadMore: "{type} +{n}",
            leadNone: "暂无动态",
            trendNew: "新增",
            trendSteady: "稳定",
            trendEnded: "已结束",
            recentEvents: "近期事件",
            headcountReduction: "裁员",
            postingCount: "{n} 个相同职位的招聘",
            loadMore: "加载更多",
            loadingMore: "加载中…",
            viewSource: "查看来源",
            via: "来源 {source}",
            sourceNews: "新闻",
            sourceJobs: "职位",
            sourceAds: "广告",
            focusMarket: "在动态中聚焦 {market}",
            drillSub: "{n} 个信号 · {types} 种类型活跃",
            hQuiet: "所有市场均无动态 — 此时间窗口内暂无信号。",
            hNew: "新增 {category} 动态 — 刚出现 {n} 个新信号。",
            hRising: "{category} 正在加速 — 较上一期增长 {pct}%。",
            hTop: "{category} 最为活跃 — 由 {type} 主导（{n} 个信号）。",
            hTopPlain: "{category} 最为活跃 — {n} 个信号。",
        },
        portfolio: {
            heading: "扩张组合",
            markets: "个市场",
        },
        timeline: {
            heading: "市场进入时间线",
            subEntry: "该公司进入各市场的顺序 — 从最早到最新",
            subMomentum: "按最近阶段势头对市场排序",
            byEntry: "按进入顺序",
            byMomentum: "按势头",
            signals: "个信号",
            signalTypes: "种信号类型",
            stageUp: "阶段升级 · {when}",
            stageUpToday: "阶段升级 · 今天",
            now: "现在",
            firstSignal: "检测到首个信号",
            longEstablished: "长期建立",
            ordinalEntered: "第 {ord} 个进入的市场",
            trackedDays: "已追踪 {n} 天",
            trackedMonths: "已追踪 {n} 个月",
            trackedYears: "已追踪 {n} 年",
            confidence: "{n}% 置信度",
            empty: "没有符合此筛选条件的市场。",
            showAll: "显示全部 {n} 个",
            showLess: "收起",
        },
        feed: {
            signalsIn: "信号所在地",
            signals: "个信号",
            via: "来源 {source}",
            reached: "达到 {stage}",
            firstSignal: "首个信号",
            show: "显示 {n}",
            hide: "隐藏",
            empty: "该市场尚未检测到任何信号。",
            emptyHint: "在地图上选择其他市场，或扩大时间范围以呈现更多动态。",
            pickTitle: "选择一个市场",
            pickHint: "在时间线上选择任意市场以探索其信号。",
            noMarketsTitle: "视图中暂无市场",
            noMarketsHint: "调整筛选条件以重新显示市场。",
            loadMore: "加载更多信号",
        },
        journey: {
            wentFirst: "最先进入",
            wentFirstSub: "按扩张顺序排列",
            movingNow: "当前进展",
            movingNowSub: "最近阶段势头",
            none: "尚无扩张市场",
            showAll: "显示全部 {n} 个",
            showLess: "收起",
        },
        dateRange: {
            today: "今天",
            last7: "近 7 天",
            last30: "近 30 天",
            last90: "近 90 天",
            last12m: "近 12 个月",
            customLabel: "自定义范围",
            startPlaceholder: "开始",
            endPlaceholder: "结束",
        },
        countryChips: {
            title: "市场",
            subtitle: "选择一个国家以定义仪表盘范围",
            ariaLabel: "已关注市场",
            addMarket: "添加市场",
            compare: "对比",
            more: "更多",
            remove: "移除市场",
            comparingNMarkets: "正在对比 {n} 个市场 | 正在对比 {n} 个市场",
            pickMarketsToCompare: "点击市场进行对比",
            multiSelectOff: "多选",
            multiSelectOnN: "多选 · {n}",
        },
        mapMode: {
            toggleAriaLabel: "地图视图模式",
            global: "所有市场",
            intoCountry: "流入",
            outgoing: "流出",
            corridorHint: "正在显示 从 → 到 的走廊 — 点击清除“到”一侧",
            backToOverview: "返回概览",
            // TODO: translate (placeholders copied from en.js)
        },
        find: {
            heading: "你在寻找什么？",
            placeholderHero: "描述一个市场——例如：正在扩张进入德国的 AI 公司",
            placeholderDocked: "描述一个市场",
            submit: "查找",
            clear: "清除",
            hintPrefix: "试试：",
            examples: [
                "扩张进入美国的金融科技公司",
                "积极扩张进入德国的 AI 公司",
                "正在拓展至英国的公司",
                "扩张进入日本的 AI 公司",
                "扩张进入法国的德国公司",
                "正在拓展至新加坡的公司",
            ],
            noMatch: "无法将其映射为筛选条件。请尝试指定市场、阶段或行业。",
        },
        compare: {
            title: "市场对比",
            pickMarket: "选择一个市场",
            emptyHint: "添加一个市场进行对比",
            totalCompanies: "已追踪公司",
            readyToContact: "可联系（拓展阶段）",
            newThisMonth: "本月新进展",
            aheadOfPace: "领先于节奏（30 天）",
            stageBreakdown: "阶段分布",
            expandingShareLabel: "就绪",
            viewMarket: "查看此市场",
            viewMarketAction: "查看",
            addColumn: "添加市场",
            removeColumn: "移除此市场",
            metricHeader: "指标",
            deltaHeader: "Δ",
            winnerBadgeTitle: "所选市场中最高",
            lensLabel: "对比维度",
            lensVolume: "总量",
            lensShare: "占比 %",
            lensShareHint: "每项指标占该市场已追踪公司的百分比",
            insightTitle: "这告诉您什么",
            insightOverall: "{winner} 在 {total} 项指标中的 {n} 项总体领先。",
            insightExpanding: "{winner} 当前比 {loser} 多出 {n} 家可联系公司。",
            insightMomentumMultiple: "本月 {winner} 获取新公司的速度比 {loser} 快 {multiple} 倍。",
            insightMomentumAbsolute: "{winner} 本月新增 {n} 家公司 — {loser} 无新增。",
            insightPace: "{market} 有 {n} 家公司发展速度高于常规 — 值得深入关注。",
            insightAboveWeight: "{winner} 表现超出体量预期 — 其市场中 {winnerPct} 可联系，而 {larger} 仅为 {largerPct}。",
            dimExpanding: "可联系",
            dimNewThisMonth: "本月新增",
            dimAheadOfPace: "领先于节奏",
            dimTotal: "已追踪总数",
            dimTotalShare: "所选市场占比",
            drillCellTitle: "打开 {country}",
            drillCellTitleStage: "打开 {country} — {stage} 阶段",
            drillSegTitle: "打开 {country} — {stage}（{n} 家公司）",
            viewCrossMarket: "在 {n} 个市场中搜索",
            summaryWinner: "{winner} 比 {loser} 多出 {n} 家可联系公司。",
            summaryTie: "两个市场拥有相同数量的可联系公司。",
        },
        countryPicker: {
            title: "添加市场",
            searchPlaceholder: "搜索国家名称或代码…",
            noMatch: "没有匹配的国家。",
        },
        stageTiles: {
            title: "阶段分布",
            subtitle: "点击阶段以筛选下方列表",
            ariaLabel: "扩张阶段",
            bestToReachOut: "最佳联系时机",
            signalsHeading: "我们关注的信号",
            signalSoon: "即将",
            infoAria: "该阶段如何判定",
        },
        stage: {
            exploring: "探索",
            exploringDescription: "正在初步了解",
            committing: "投入",
            committingDescription: "正在投入实际资源",
            expanding: "拓展",
            expandingDescription: "正在深化本地布局",
            scaling: "规模化",
            scalingDescription: "正在扩大本地规模",
        },
        signal: {
            ad: "地域定向广告",
            event: "会议参与",
            news: "新闻 / 公关",
            dns: "云端足迹",
            dnsInsight: "检测到此市场的云端基础设施。",
            tech: "产品本地化",
            infra: "资本投资",
            ip: "商标 / 专利",
            partner: "合作伙伴",
            eventPlus: "参展 / 演讲",
            reg: "监管牌照",
            entity: "实体注册",
            exec: "高管聘任",
            office: "办公室租赁",
            hire: "本地团队招聘",
            scale: "人员规模扩张",
            product: "产品发布",
        },
        signalTier: {
            premier: "顶级",
        },
        direction: {
            advancing: "推进中",
            steady: "稳定",
            retreating: "撤退",
            new: "新增",
        },
        freshness: {
            fresh: "新鲜",
            cooling: "降温",
            stale: "陈旧",
            cold: "冷却",
        },
        filters: {
            title: "筛选",
            clearAll: "清除全部",
            direction: "方向",
            freshness: "新鲜度",
            employees: "员工人数",
            industry: "行业",
            risk: "风险",
            stage: "阶段",
            scope: "范围",
            founded: "成立时间",
            signalStrength: "信号强度",
            signalVolume: "信号数量",
            momentum: "动能",
            momentumAccelerating: "加速中",
            momentumAdvancing: "推进中",
            momentumSteady: "稳定",
            momentumPullingBack: "回落中",
            signalVolumeAny: "全部",
            signalVolumeWord: "信号",
            onlyAtRisk: "仅显示风险市场",
            any: "任意",
            employeesCustomRange: "自定义范围",
            predefinedRange: "预设范围",
            employeesPlaceholder: "选择规模范围",
            industrySubCategory: "细分行业",
            industryCategory: "行业类别",
            industrySubCategoryPlaceholder: "输入细分行业",
            industryCategoryPlaceholder: "输入行业类别",
            foundedRange: "成立年份",
            foundedFrom: "起始",
            foundedTo: "截止",
            min: "最小",
            max: "最大",
            // TODO: translate (placeholders copied from en.js)
            signalType: "信号类型",
            pace: "节奏",
            onlyAheadOfPace: "仅显示领先节奏",
            paceHint: "从首个信号到最新阶段变化的耗时处于该国最快四分位的公司。",
            searchPlaceholder: "搜索筛选…",
            presets: "筛选预设",
            presetsSavedCount: "已保存 {n} 个",
            activeOne: "{n} 个筛选生效中",
            activeMany: "{n} 个筛选生效中",
            moreChips: "+{n} 更多",
            lessChips: "收起",
            save: "保存",
            clearShort: "清除",
            groupScope: "范围",
            groupSignal: "扩张信号",
            groupSources: "信号来源",
            route: "市场",
            routeFrom: "从",
            routeTo: "到",
            routeAnywhere: "任意地区",
            routeToOneWay: "切换为双向",
            routeToEither: "切换为单向",
            routeOneWayLabel: "单向",
            routeEitherLabel: "双向",
            routeSummaryEmpty: "任意地区",
            routeLoopNote: "{market} 同时出现在“从”和“到”中。扩张路线均为跨境，因此不会有任何结果。",
            routeLoopKeepFrom: "保留 {code} → 任意地区",
            routeLoopKeepTo: "保留 任意地区 → {code}",
            routeInFromTag: "已在“从”",
            routeInToTag: "已在“到”",
            routeExclude: "排除目的地",
            groupCompany: "公司资料",
            date: "日期",
            markets: "进入 · 目标市场",
            flowDirection: "流向",
            marketsPlaceholder: "扩张到哪里（目的地）",
            noMatchingFilters: "没有匹配的筛选",
            addFilter: "添加筛选",
            groupRecent: "最近",
            groupSuggested: "推荐",
            savedViews: "已保存的筛选",
            savedViewsCount: "已保存 {n} 个",
            noSavedViews: "暂无已保存的筛选。",
            saveCurrentView: "保存当前筛选",
            deleteView: "删除筛选",
            deleteConfirm: "删除",
            cancel: "取消",
            confirmDeleteView: "确定删除已保存的筛选“{name}”吗？",
            saveDialogTitle: "保存筛选",
            namePrompt: "为该筛选命名，方便日后调用。",
            namePlaceholder: "例如：热门欧洲 SaaS",
            nameRequired: "请填写筛选名称。",
            location: "来自 · 公司总部",
            revenue: "营收",
            revenueRange: "年度营收（美元）",
            revenueMin: "最小（$）",
            revenueMax: "最大（$）",
            revenueHint: "来自增强数据的预估年度营收区间。",
            specialties: "专长",
            specialtiesPlaceholder: "搜索专长…",
            technologies: "技术",
            technologiesPlaceholder: "搜索技术…",
            companies: "公司",
            companiesPlaceholder: "搜索公司…",
            activeTitle: "生效中",
            activeEmpty: "没有生效的筛选",
            dateChipPrefix: "日期",
            marketChipPrefix: "市场",
            savedListChip: "已保存列表",
            savedListFilterNote: "每家公司按其达到的最高阶段显示一行。阶段图块与列表数量一致。",
            originChipPrefix: "来自",
            targetChipPrefix: "进入",
            removeFilter: "移除 {label}",
          stageDesc: "公司在该市场的活跃程度 — 从首个信号到规模化扩张。",
          momentumDesc: "扩张的趋势方向 — 加速、稳定或回落。",
          signalVolumeDesc: "我们检测到的扩张信号数量。信号越多，活动越活跃。",
          signalTypeDesc: "信号的种类 — 招聘、广告、新办公室、新闻等。",
          freshnessDesc: "最新信号的新鲜程度。",
          scopeDesc: "进入全新市场，还是深耕已有市场。",
          signalTypeUnavailable: "即将推出 — 该信号暂不可用",
          excludeMarkets: "排除市场",
          excludeMarketsPlaceholder: "要排除的市场…",
          excludeOrigins: "排除出发地",
          excludeOriginsPlaceholder: "要排除的出发地",
          excludeIndustry: "排除行业",
          excludeIndustryPlaceholder: "要排除的行业…",
        },
        scope: {
            enteringNewMarket: "进入新市场",
            expandingWithinPresence: "在已有市场内扩张",
            establishedOnly: "仅已建立的市场",
        },
        signalStrength: {
            high: "高置信度",
            medium: "中等",
            low: "低",
        },
        row: {
            employees: "员工",
            marketsCount: "{n} 个市场",
            marketsActiveIn: "活跃于 {list}",
            founded: "成立",
            journey: "进程",
            journeyLabel: "进程",
            contractionFlag: "{days} 天内无新信号。该公司可能正在暂停或退出扩张。",
            noSignalsInDays: "{days} 天内无新信号。该公司可能正在暂停或退出扩张。",
            movingFast: "快速发展中",
            movingFastDetail: "{months} 个月内 {stages}。",
            addToSequence: "加入序列",
            saveToList: "保存到列表",
            viewProfile: "查看档案",
            viewSignalsHint: "点击查看所有信号",
            signalCount: "{n} 个信号",
            distinctTypes: "{n} 种信号类型",
            stageUpInDays: "阶段升级 · {days} 天前",
            stageUpToday: "阶段升级 · 今天",
            newInDays: "新增 · {days} 天",
            newToday: "新增 · 今天",
            selectRow: "选择公司",
            lastSignal: "最近信号",
            // TODO: translate (placeholders copied from en.js)
            contractionFlag_leading: "Early signs of contraction — multiple leading indicators (exec departures, layoff chatter) in the last 60 days.",
            contractionFlag_confirming: "Recent contraction signal — a layoff or downsizing was reported in the last 180 days.",
            contractionFlag_lagging: "Confirmed retreat — a market exit, office closure or de-registration in the last 12 months.",
            contractionFlag_leading_mixed: "Mixed signals — early contraction indicators alongside ongoing expansion activity. Watch closely.",
            contractionFlag_confirming_mixed: "Mixed signals — a recent contraction signal sits alongside fresh expansion activity. Confidence is split; review before acting.",
            stageOf: "Stage {n} of {total}",
            tooltipDirection_advancing: "Moved up at least one stage in the last 30 days",
            tooltipDirection_steady: "No stage change in the last 30 days",
            tooltipDirection_retreating: "Fewer recent signals — this company may be pulling back from this market",
            tooltipDirection_new: "Just appeared as a potential expander",
            tooltipFreshness_fresh: "Last signal in the past 30 days",
            tooltipFreshness_cooling: "Last signal 30 to 60 days ago",
            tooltipFreshness_stale: "Last signal 60 to 90 days ago — activity has cooled",
            tooltipFreshness_cold: "No signals in the past 90 days",
            tooltipSignalCount: "Total expansion signals tracked for this company ({n})",
            tooltipDistinctTypes: "{n} different kinds of signal (hiring, news, office lease, etc.)",
            tooltipStageUp: "Recently moved up to the {stage} stage",
            tooltipNew: "First signal detected recently",
            tooltipSignalType: "Signal type: {type}",
        },
        list: {
            title: "{count} 家公司",
            titleAll: "{country} 中有 {count} 家公司",
            titleAllGlobal: "所有市场共 {count} 家公司",
            titleStageScoped: "{count} 家公司处于 {stage} — {country}",
            titleStageScopedGlobal: "{count} 家公司处于 {stage} — 所有市场",
            filteredBy: "筛选条件",
            export: "导出",
            previous: "上一页",
            next: "下一页",
            pageOf: "第 {page} 页 / 共 {total} 页",
            selectAll: "全选",
            sortLabel: "排序",
            sortRelevance: "相关度",
            sortRecent: "最新",

            selectAllOption: "全部",
            selectThisPage: "本页",
            selectCustomize: "自定义",
            selectHint: "在此视图中最多选择 {count} 家公司。",
            applySelection: "应用",
            selected: "已选 {n} 家",
            bulkSequence: "加入序列",
            bulkSave: "保存到列表",
            bulkExport: "导出所选",
            findPeople: "查找联系人",
            clearSelection: "清除",
            paceHint: "{country} 中探索 → 拓展的中位数为 6 个月。{n} 家公司领先于节奏。",
            movingFast: "快速发展中",
            movingFastDetail: "4 个月内完成探索 → 规模化。{country} 中 SaaS 行业中位数为 6 个月。",
            emptyTitle: "暂无公司匹配此视图。",
            emptyBody: "尝试其他市场或等待新信号到来。",
            emptyStageTitle: "当前此阶段暂无公司。",
            emptyStageBody: "选择其他阶段继续探索。",
            emptyRouteTitle: "此时间窗口内没有 {from} → {to} 的动向。",
            emptyRouteBody: "放宽路线的一端，或延长日期范围。",
            emptyLoopTitle: "市场无法向自身扩张。",
            emptyLoopBody: "{market} 位于路线的两端。保留一端并放开另一端，即可查看跨境动向。",
            emptyRouteKeepFrom: "{code} → 任意地区",
            emptyRouteKeepTo: "任意地区 → {code}",
            pickCountryTitle: "选择一个国家开始。",
            pickCountryBody: "点击上方的市场标签（或使用地图）以定义仪表盘范围。",
        },
        map: {
            topSectors: "主要行业",
            expandingInto: "扩张至",
            comingFrom: "来自",
            placeholderAriaLabel: "扩张世界地图",
            loadingBasemap: "正在加载底图…",
            loadingCountry: "正在加载市场数据…",
            loadingDashboard: "正在加载扩张数据…",
            newThisMonthIn: "{country} 本月新增",
            newTransitionsAllMarkets: "本月新进展",
            readyToContact: "可联系",
            tracked: "已追踪总数",
            activeMarkets: "活跃市场",
            ctaReadyToContact: "查看 {n} 家可联系公司",
            origins: {
                title: "主要来源 → {country}",
                total: "{n} 家跨境",
                domestic: "+{n} 家本地（{country} → {country}）",
                untracked: "+{n} 个来源尚未追踪",
                empty: "此市场暂无来源数据。",
                plusMore: "+{n} 个更多来源",
                clearFilter: "清除来源筛选",
            },
            timeFilterLabel: "显示信号时间范围",
            timeFilterToday: "今天",
            timeFilterWeek: "本周",
            timeFilterMonth: "本月",
            timeFilterAll: "全部时间",
            activityFeedTitle: "最新动态",
            activityFeedEmpty: "所选时间范围内无新动态。",
            activityFeedFooter: "查看所有动态 →",
            activityFeedAdvanced: "已进入 {stage}",
            activityFeedNew: "检测到新信号",
            activityFeedFrom: "来自{country}",
            activityFeedTitleHint: "点击查看公司详情",
            activityFeedTitleHintCountry: "点击聚焦此市场",
            marketIntelTitle: "市场情报",
            tabOrigins: "主要来源",
            tabWhatsNew: "最新动态",
            tabActivity: "刚刚变动",
            whatsNewAriaLabel: "市场动态洞察",
            whatsNewLoading: "正在计算…",
            whatsNewEmpty: "所选时段暂无变动。请在地图控件中调整时间范围。",
            whatsNewMovesLabel: "次本期变动",
            whatsNewVsPrev: "对比{label} {n} 次",
            whatsNewPrevDay: "昨日",
            whatsNewPrevWeek: "上周",
            whatsNewPrevMonth: "上月",
            whatsNewPrevDays: "过去 {n} 天",
            whatsNewHotCorridors: "热门走廊",
            whatsNewSurgingDestinations: "目的地激增",
            whatsNewSurgingOrigins: "来源激增",
            whatsNewStageVelocity: "阶段速度",
            whatsNewNotableMovers: "重点动态",
            whatsNewDeltaNew: "新",
            whatsNewDeltaFlat: "持平",
            whatsNewCorridorHint: "筛选列表为 {from} → {to}",
            whatsNewDestinationHint: "聚焦 {country} 市场",
            whatsNewOriginHint: "筛选来自 {country} 的公司",
            whatsNewStageHint: "筛选 {stage} 阶段",
            whatsNewScopeGlobal: "全部市场",
            whatsNewScopeMulti: "{n} 个市场",
            whatsNewWindowToday: "今日",
            whatsNewWindowWeek: "近 7 天",
            whatsNewWindowMonth: "近 30 天",
            whatsNewWindowDays: "近 {n} 天",
            whatsNewViewAll: "查看列表中所有公司",
            whatsNewViewAllN: "查看全部 {n} 家公司",
            whatsNewWhereFrom: "主要来源地",
            whatsNewPipelineMix: "阶段分布",
            whatsNewCaptionGlobal: "全部市场动态 · {window}",
            whatsNewCaptionCountry: "进入 {country} 的动态 · {window}",
            whatsNewCaptionMulti: "{n} 个市场动态 · {window}",
            whatsNewTabForYou: "为你筛选",
            whatsNewTabFastMovers: "快速进展",
            whatsNewTabWideExpanders: "全面扩张",
            whatsNewWideExplainer: "近期同时进入 3 个以上新市场的公司 — 多国并行扩张。",
            whatsNewWideEmptyTitle: "此范围内暂无全面扩张的公司",
            whatsNewWideEmptyBody: "尝试扩大时间范围或清除国家筛选，以查看同时进入多个市场的公司。",
            whatsNewMarketsCount: "{n} 个新市场",
            whatsNewMarketsInlineMore: "另有 {n} 个",
            whatsNewFoundedYear: "成立于 {year}",
            whatsNewOpenList: "打开列表：{name}",
            whatsNewForYouExplainer: "您保存的公司列表中,在此时间范围内有新进展的列表。",
            whatsNewForYouEmptyTitle: "您的列表暂无新动向",
            whatsNewForYouEmptyBody: "您保存的公司在此时间范围内尚未发生阶段变化。请扩大时间范围或稍后再查看。",
            whatsNewUnnamedList: "未命名列表",
            whatsNewListCount: "{n} 家公司",
            whatsNewListUpdated: "更新于 {time}",
            whatsNewSavedListMovers: "{count} 家有新动向",
            whatsNewSavedListMoversAriaLabel: "此列表有 {count} 家公司有新动向",
            whatsNewSavedListTotal: "共 {total} 家",
            whatsNewFastMoversTitle: "进展超前的公司",
            whatsNewFastEmptyTitle: "此范围内暂无快速进展公司",
            whatsNewFastEmptyBody: "尝试扩大时间范围或清除国家筛选，以查看进展超前的公司。",
            whatsNewFastExplainer: "进展快于市场 75% 同行的公司。",
            whatsNewMovingFastDetail: "{from} → {to}，{months} 个月内",
            whatsNewStageUpAt: "阶段提升 · {time}",
            whatsNewViewList: "查看完整公司列表",
            whatsNewMarketsChip: "已进入 {n}+ 个市场",
            whatsNewVerbInto: "进入 {scope}",
            whatsNewVerbAcross: "跨境动态",
            whatsNewVelocityTitle: "本期 {n} 家公司{verb}",
            whatsNewVelocityDetail: "上一{window}为 {previous} 家",
            whatsNewVelocityDetailNoPrior: "首次出现有效活动",
            whatsNewStoryNew: "{from} → {to} 是本期新走廊",
            whatsNewStoryNewDetail: "{n} 家公司刚完成迁移 — 首次记录到此走廊",
            whatsNewStorySurge: "{from} → {to} 激增 {delta}%",
            whatsNewStoryCool: "{from} → {to} 降温 {delta}%",
            whatsNewStoryDeltaDetail: "本期 {current} 次 vs 上一期 {previous} 次",
            whatsNewStoryStageUp: "{stage} 阶段上升 {delta}%",
            whatsNewStoryStageDown: "{stage} 阶段下降 {delta}%",
            whatsNewStoryStageDetail: "{n} 家公司刚进入 {stage}",
            whatsNewStoryMover: "{company} 刚进入 {stage}",
            showActivity: "显示市场情报",
            hideActivity: "隐藏市场情报",
            windowEmptyBody: "扩大日期范围以显示该公司的活动。",
      noActivityTitle: "此视图中暂无动态。",
            noActivityBody: "选择其他市场或切换至全局流向视图。",
            noOutgoingTitle: "{country} 暂无向外扩张信号",
            noOutgoingBody: "我们在当前数据中未检测到任何公司从 {country} 向外扩张。请尝试切换至已选市场视图，查看正在向此国家扩张的公司。",
            noOutgoingCta: "查看向此市场扩张的公司",
            companiesCount: "{n} 家公司 | {n} 家公司",
            newThisMonthCount: "本月新增 {n} 家",
            clickHint: "悬停查看市场详情 · 点击深入了解",
            zoomIn: "放大",
            zoomOut: "缩小",
            resetView: "重置视图",
            densityShowN: "最多 {n} 个市场 | 最多 {n} 个市场",
            densitySliderAriaLabel: "地图密度 — 滑动以显示更多或更少来源",
            legendAriaLabel: "地图图例",
            legendTitle: "阶段",
            legendSectionRecent: "近期动态",
            legendStageUp: "推进中",
            legendStageUpTitle: "青色圆环标记近 30 天内阶段升级的国家",
            legendNew: "新增",
            legendNewTitle: "发光圆点标记近 90 天内启动扩张的国家",
            legendBadge30d: "30 天",
            legendBadge90d: "90 天",
            legendCollapse: "最小化图例",
            legendExpand: "显示图例",
            companies: "家公司",
            // TODO: translate (placeholders copied from en.js)
            activityFeedEmptyGlobal: "Pick a market above to see companies that just moved stages.",
        },
        tooltip: {
            signals: "个信号",
            companiesMoving: "家公司正在变动",
            companiesExpandingFrom: "家公司从此处向外扩张",
            companiesArrivingAt: "家公司从此来源进入",
            clickToScope: "点击筛选列表 →",
        },
        popover: {
            close: "关闭",
            loading: "正在加载详情…",
            loadFailed: "无法加载此市场。",
            keyMoments: "关键节点",
            signals: "信号（{n}）",
            firstSignal: "首个信号",
            latestSignal: "最新信号",
            reachedStage: "达到 {stage}",
            stageUp: "阶段升级",
        },
        drawer: {
            title: "公司扩张档案",
            currentStage: "当前阶段",
            confidence: "置信度",
            confidenceHigh: "高",
            confidenceMedium: "中等",
            confidenceLow: "低",
            signalGeneric: "信号",
            allSignals: "信号时间线",
            signalsCount: "{n} 个信号",
            noSignals: "此市场组合尚未捕获详细信号。",
            contractionBanner: "检测到收缩信号 — 联系前请核实该公司是否仍在扩张。",
            openFullProfile: "打开完整档案",
            visitWebsite: "访问网站",
            // Expansion context (route between hero card and stage strip)
            expandingInto: "扩张至",
            expandingFrom: "来自",
            expansionTo: "扩张至",
            signalsInMarket: "信号所在地",
            // Company overview tile
            companyAtAGlance: "公司概览",
            industry: "行业",
            founded: "成立",
            employees: "员工",
            headquarters: "总部",
            website: "网站",
            // Presence section
            onTheGround: "本地实体",
            presenceOffice: "办公室",
            presenceLegal: "法人实体",
            presenceHiring: "招聘",
            // TODO: translate
            milestoneActiveRoles: "Reached {n} active role | Reached {n} active roles",
            milestoneScale: "Reached open-roles threshold",
            // Other markets
            alsoExpandingTo: "同时扩张至",
            noOtherMarkets: "尚未检测到其他市场。",
            showAll: "显示全部（{n}）",
            showLess: "收起",
            filterAll: "全部",
            // Pace
            paceLabel: "扩张节奏",
            paceText: "从首个信号到 {stage} 用时 {days} 天",
            paceFast: "快",
            paceTypical: "常规",
            paceSlow: "慢",
            localTeamLabel: "本地团队",
            lastActiveLabel: "最近活动",
            teamPeople: "人",
            localTeamNone: "无",
            localTeamNetNew: "全新市场",
            localTeamEmerging: "初步布局",
            localTeamEstablished: "已入驻",
            localTeamNoData: "—",
            localTeamNoDataMeta: "无本地数据",
            localTeamOnSite: "已驻点",
            readScalingTitle: "扩张现有团队",
            readScalingDetail: "已在{market}扎根——近期招聘与广告是在扩张现有的本地业务，而非新进入。",
            readDeepeningTitle: "深化本地布局",
            readDeepeningDetail: "已在{market}扎根并持续加码——是在扩张现有业务，而非首次进入。",
            readSteadyTitle: "本地运营中",
            readSteadyDetail: "已在{market}扎根，本地活动持续稳定。",
            readEstablishingTitle: "正在建立据点",
            readEstablishingDetail: "已在{market}有小团队——近期信号显示正在扩充。",
            paceInMarket: "已在本地",
            thisMarket: "该市场",
            readAxesFootnote: "阶段反映近期动态 · 团队反映规模——两者可能不同。",
            teamFoundDetail: "在{market}已找到 {n} 人——实际可能更多。",
            // Signal labels
            signalSource: "来源 {source}",
            signalTierHint: "难以获取的情报，由 Pubrio 发掘呈现",
            signalSurfacedByPubrio: "由 Pubrio 发现",
            signalSourceFrom: "来源 {source} · {host}",
            signalViewSource: "查看来源",
            signalNoEvidence: "无可用来源链接",
            // Footer note
            poweredBy: "最近检测信号",
            // TODO: translate (placeholders copied from en.js)
            signalsCountOf: "{n} of {total} signals",
            loadMore: "Load more signals",
            switchMarket: "Switch market",
            durationDays: "{n}d",
            durationWeeks: "{n}w",
            durationMonths: "{n}mo",
            durationYears: "{n}y",
            reachedStageAt: "Reached {stage} {when}",
            transitionDuration: "{duration} in {prev}",
            signalGroupTitle: "{n} × {type}",
            signalGroupContext: "{items}",
            headcountScalingTitle: "{n} jobs currently open",
            recentSignalsChip: "{n} {type} · 12w",
            activityLabel: "Activity",
            activityWindow: "{weeks} weeks",
            activityTotal: "All",
            activityFilterByType: "Filter timeline to {type}",
            activityCellTooltip: "{n} × {type} · {week}",
            activityCellMore: "+{n} more",
            activityCellEmpty: "No {type} signals · {week}",
            activityEmpty: "Quiet for now",
            activityEmptyHint: "No signals detected in the last 12 weeks — this company's expansion engine is paused or pre-launch.",
            snapshotLabel: "Current snapshot",
            showItems: "Show {n}",
            showItemsOf: "Show {n} of {total}",
            dnsServers: "{n} 台服务器 | {n} 台服务器",
            dnsRegionCode: "云服务商的区域代码",
            hideItems: "Hide",
            loadingMore: "Loading…",
        },
        live: {
            title: "市场动态",
            live: "实时",
            all: "全部",
            advancing: "推进中",
            retreating: "撤退",
            tabNews: "新闻",
            tabFunding: "融资洞察",
            tabJobs: "招聘信息",
            tabAds: "广告",
            sort: "排序",
            sortNewest: "最新优先",
            sortOldest: "最早优先",
            sortImpact: "影响力",
            filter: "筛选",
            findPeople: "查找联系人",
            searchPlaceholder: "搜索 …",
            pendingBanner: "自上次访问以来有 {n} 条新文章 · 点击加载",
            empty: "暂无变动 — 公司动态将在此处显示。",
            lastHour: "最近一小时",
            advanced: "已推进至",
            retreated: "已撤离自",
            decayed: "已衰退自",
            changed: "已转变为",
        },
        trending: {
            title: "热门公司",
            mostActiveToday: "今日最活跃",
            catAll: "全部",
            catTechnology: "科技",
            catFintech: "金融科技",
            catHealthcare: "医疗健康",
            catSaaS: "SaaS",
            more: "更多",
            empty: "暂无热门公司。",
        },
        toast: {
            sequenceQueued: "已打开加入序列 — 请从弹窗中选择序列。",
            savedToList: "已将 {name} 保存到您的列表。",
            saveFailed: "无法保存到列表。请重试。",
            exportReady: "已导出 {n} 行。",
            exportFailed: "导出失败 — 请尝试较小批次。",
        },
        export: {
            title: "导出扩张数据为 CSV",
            body: "导出 {count} 行 CSV 将使用 {price} 信用点。",
        },
        watch: {
            cta: "关注此视图",
            ctaShort: "关注",
            watching: "关注中",
            newCount: "{n} 条新增",
            cadenceHeading: "提醒方式",
            start: "开始关注",
            recommended: "推荐",
            update: "更新监控",
            realtime: "实时",
            realtimeDesc: "每当有信号出现",
            daily: "每日摘要",
            dailyDesc: "每天一次汇总",
            weekly: "每周摘要",
            weeklyDesc: "每周一汇总",
            statusActive: "已启用",
            statusPaused: "已暂停",
            newMatches: "新匹配",
            lastChecked: "上次检查",
            never: "尚未运行",
            frequency: "频率",
            scope: "范围",
            scopeSummary: "{market} · {n} 个筛选条件",
            allMarkets: "所有市场",
            viewMatches: "查看匹配",
            pause: "暂停",
            resume: "恢复",
            stop: "停止关注",
            namePlaceholder: "为此监控命名",
            defaultName: "{market} · 扩展信号",
            monitorName: "{market} · 扩展信号 #{date}",
            created: "已关注 — 有新信号时将通知你",
            updated: "监控已更新",
            stopped: "已停止关注",
            paused: "监控已暂停",
            resumed: "监控已恢复",
            viewChanged: "筛选条件已更改 — 请更新你的监控",
            empty: "添加市场或筛选条件以关注此视图",
        },
        widgetRail: {
            title: "更多小部件",
            expandHint: "点击展开",
        },
        errors: {
            loadFailed: "无法加载扩张数据。",
            retry: "重试",
        },
        time: {
            unknown: "—",
            today: "今天",
            daysAgo: "{n} 天前",
            weeksAgo: "{n} 周前",
            monthsAgo: "{n} 个月前",
            yearsAgo: "{n} 年前",
        },
    },

    // TODO: translate (placeholders copied from en.js)
    exportingLeadsToACSV: "Exporting leads to a CSV will use {count} credit. | Exporting leads to a CSV will use {count} credits.",
};
